import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

export const journal: RouteRecordRaw = {
  path: 'journal',
  name: 'admin.journal',
  component: () => import('pages/admin/journal/Journal.vue'),
  redirect: { name: 'admin.journal.activity.selector' },
  meta: {
    roles: [
      Roles.CenterAdmin,
      Roles.OfficeStaff,
      Roles.OrgAdmin,
      Roles.RoomStaff,
      Roles.SuperAdmin,
    ],
    supportedPlatforms: ['desktop', 'mobile', 'native'],
  },
  children: [
    {
      name: 'admin.journal.students',
      path: 'students',
      component: () => import('components/journal/Main.vue'),
      meta: {
        roles: [
          Roles.CenterAdmin,
          Roles.OfficeStaff,
          Roles.OrgAdmin,
          Roles.RoomStaff,
          Roles.SuperAdmin,
        ],
      },
    },
    {
      name: 'admin.journal.activities',
      path: 'activities',
      component: () => import('components/journal/JournalDailyView.vue'),
      meta: {
        roles: [
          Roles.CenterAdmin,
          Roles.OfficeStaff,
          Roles.OrgAdmin,
          Roles.RoomStaff,
          Roles.SuperAdmin,
        ],
      },
    },
    {
      name: 'admin.journal.activity.selector',
      path: 'activity',
      component: () => import('components/journal/ActivitySelector.vue'),
      meta: {
        roles: [
          Roles.CenterAdmin,
          Roles.OfficeStaff,
          Roles.OrgAdmin,
          Roles.RoomStaff,
          Roles.SuperAdmin,
        ],
      },
    },
    {
      name: 'admin.journal.activity.create',
      path: 'activity/:type',
      component: () => import('components/journal/ActivityEditor.vue'),
      meta: {
        roles: [
          Roles.CenterAdmin,
          Roles.OfficeStaff,
          Roles.OrgAdmin,
          Roles.RoomStaff,
          Roles.SuperAdmin,
        ],
      },
    },
    {
      name: 'admin.journal.activity.edit',
      path: 'activity/:id/edit',
      component: () => import('components/journal/ActivityEditor.vue'),
      meta: {
        roles: [
          Roles.CenterAdmin,
          Roles.OfficeStaff,
          Roles.OrgAdmin,
          Roles.RoomStaff,
          Roles.SuperAdmin,
        ],
      },
    },
    {
      name: 'admin.journal.students.activities',
      path: 'students/:studentId/activities',
      component: () => import('pages/admin/journal/StudentActivities.vue'),
      meta: {
        roles: [
          Roles.CenterAdmin,
          Roles.OfficeStaff,
          Roles.OrgAdmin,
          Roles.RoomStaff,
          Roles.SuperAdmin,
        ],
      },
    },
    {
      name: 'admin.journal.activities.pending',
      path: 'activities/approval/pending',
      component: () => import('components/journal/PendingApprovals.vue'),
      meta: {
        roles: [
          Roles.CenterAdmin,
          Roles.OfficeStaff,
          Roles.OrgAdmin,
          Roles.SuperAdmin,
        ],
      },
    },
    {
      name: 'admin.journal.acknowledgments',
      path: 'activities/acknowledgments',
      component: () => import('components/journal/Acknowledgments.vue'),
      meta: {
        roles: [
          Roles.CenterAdmin,
          Roles.OfficeStaff,
          Roles.OrgAdmin,
          Roles.SuperAdmin,
        ],
      },
    },
  ],
}
